module.exports = __webpack_public_path__ + "static/media/01-galeria-03-cartier@2x.5ac5acad.jpg";